import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { HEADER_HEIGHT } from '@/lib/constants/hyperTrackerConstants';
import Select from '@mui/material/Select';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    positions: 'relative',
    width: '100%',
    position: 'relative',
    backgroundColor: theme.palette.primitives.woodsmoke[1000],
    zIndex: 3,
}));

export const HeaderContent = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: `${HEADER_HEIGHT}px`,
    padding: '0 20px 0 80px',
}));

export const ButtonsBlockDesktop = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
}));

export const MenuIconMobile = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));

export const NavigationSection = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
}));

export const HeaderLeft = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '30px',
}));

export const HeaderRight = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    width: '100%',
});

export const SelectStyled = styled(Select)(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    color: theme.palette.customText.text4,
    minWidth: '100px',

    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
}));

export const MobileAuthWindowWrapper = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '80px',
    left: 0,
    height: 'calc(100vh - 80px)',
    width: '100vw',
    overflowY: 'scroll',
    backgroundColor: theme.palette.background.default,
    zIndex: 100,

    '&::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const MobileSearchButton = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '4px',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));

export const VerticalDivider = styled(Box)(({ theme }) => ({
    width: '1px',
    height: '20px',
    display: 'flex',
    backgroundColor: theme.palette.backgrounds.bg3,
}));
